import { useRef, useState } from "react";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import { MUTED, QUARTERLY_METRIC_COLORS } from "../constants";
import { exportPanelsSeparately } from "../exportUtils";
import { QuarterlyAverageMetricPanel } from "./QuarterlyAverageMetricPanel";
import { SectionTitle } from "./SectionTitle";

export function QuarterlyAveragesCard({ chart, isLoading }) {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const avgSpendRef = useRef(null);
  const avgKgRef = useRef(null);
  const avgItemsRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = async () => {
    if (isLoading) return;
    setIsExporting(true);
    try {
      await exportPanelsSeparately(
        headerRef,
        [
          { ref: avgSpendRef, suffix: `_${chart?.avg_spend?.title || "Avg_Spend"}` },
          { ref: avgKgRef, suffix: `_${chart?.avg_kg?.title || "Avg_Kg"}` },
          { ref: avgItemsRef, suffix: `_${chart?.avg_items?.title || "Avg_Items"}` },
        ],
        chart?.title || "Quarterly_Averages"
      );
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <section ref={sectionRef} className="min-w-0 rounded-2xl border border-[#d6dfeb] bg-white shadow-sm overflow-hidden flex flex-col">
      <div className="px-4 pt-4" ref={headerRef}>
        <SectionTitle title={chart?.title || "Quarterly Averages"} icon={faChartColumn} rulesKey="quarterlyAverages" onExport={handleExport} isExporting={isExporting} disabled={isLoading} />
        {chart?.subtitle && (
          <p className="text-xs mt-1" style={{ color: MUTED }}>{chart.subtitle}</p>
        )}
      </div>
      <div className="px-3 pt-3 pb-4">
        {isLoading ? (
          <div className="h-[260px] flex items-center justify-center text-sm" style={{ color: MUTED }}>Loading…</div>
        ) : (
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
            <div ref={avgSpendRef}>
              <QuarterlyAverageMetricPanel metric={chart?.avg_spend} height={240} colors={QUARTERLY_METRIC_COLORS.avg_spend} />
            </div>
            <div ref={avgKgRef}>
              <QuarterlyAverageMetricPanel metric={chart?.avg_kg} height={240} colors={QUARTERLY_METRIC_COLORS.avg_kg} />
            </div>
            <div ref={avgItemsRef}>
              <QuarterlyAverageMetricPanel metric={chart?.avg_items} height={240} colors={QUARTERLY_METRIC_COLORS.avg_items} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
